import { Directive, ElementRef, Renderer2, Input, OnInit, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[softKeyboard]'
})
export class SoftKeyboardDirective implements OnInit, AfterViewInit, OnChanges {
  ngOnChanges(changes: SimpleChanges): void {
    this.setState();
  }
  originalReadOnly: boolean;
  originalBackgroundColor: string;
  ngAfterViewInit(): void {


    var input = (this.elementRef.nativeElement as HTMLElement).querySelector("input");
    if (input) {
      this.originalReadOnly = input.readOnly;
      this.originalBackgroundColor = input.style.backgroundColor;
    }
    this.setState();
    // if (input) {
    //   this.originalReadOnly = input.readOnly;
    //   this.originalBackgroundColor = input.style.backgroundColor;
    //   if (this.softKeyboard) {
    //     input.readOnly = true;
    //     input.style.backgroundColor = "transparent"
    //     // this.render.addClass("disable-soft-key")
    //   }
    //   else {
    //     input.readOnly = this.originalReadOnly;
    //     input.style.backgroundColor = this.originalBackgroundColor;
    //   }

    //   //this.render.setProperty(input, "readOnly", this.softKeyboard);

    // }
  }

  setState() {
    var input = (this.elementRef.nativeElement as HTMLElement).querySelector("input");
    if (input) {
      if (!this.softKeyboard) {
        input.readOnly = true;
        input.style.backgroundColor = "transparent"
        // this.render.addClass("disable-soft-key")
      }
      else {
        input.readOnly = this.originalReadOnly;
        input.style.backgroundColor = this.originalBackgroundColor;
      }
    }
  }


  constructor(private elementRef: ElementRef, private render: Renderer2) {

  }

  ngOnInit(): void {

    // var input = (this.elementRef.nativeElement as HTMLElement).querySelector("input");
    // if (input) {
    //   input.readOnly = !this.softKeyboard;
    //   //this.render.setProperty(input, "readOnly", this.softKeyboard);

    // }
  }
  @Input()
  softKeyboard: boolean;


}
